module.exports = __webpack_public_path__ + "img/app_logo_white_hr_001.6f0d91c0.png";